import { ContractingPartnersController } from './contractingPartners.controller';
import template from './contractingPartners.html';

export const contractingPartnersComponent = {
  name: 'contractingPartners',
  restrict: 'E',
  template,
  controller: ContractingPartnersController,
  controllerAs: 'vm',
  bindings: {
    selected: '<',
    onSelect: '&'
  }
};
